module.exports = __webpack_public_path__ + "img/gab1.c65374dd.jpg";